module.exports = __webpack_public_path__ + "static/media/tutor-id-2.9d0835ee.jpg";